import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import { BsFillPinFill } from "react-icons/bs";
import BettingSlip from "../BettingSlip";
import { BookmakerMultipin } from "../../api";
import { useNavigate } from "react-router-dom";

const ODDS_INDEXES = [0, 1, 2];

const Bookmaker = () => {
  const { cricket, soccer, tennis } = useSelector((state) => ({
    cricket: state.matches.cricket.matches?.data || [],
    soccer: state.matches.soccer.matches?.data || [],
    tennis: state.matches.tennis.matches?.data || [],
  }));
  const [selectedBet, setSelectedBet] = useState(null);
  const [localBetData, setLocalBetData] = useState(null);
  const [marketData, setMarketData] = useState([]);
  console.log(selectedBet, "selectedBet in Bookmaker");

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pinnedMatches, setPinnedMatches] = useState([]);
  const [blinkCells, setBlinkCells] = useState({}); // Track cells to blink
  const prevOddsRef = useRef({}); // Store previous odds

  const navigate = useNavigate();

  // Load pinned matches from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem("pinnedMatches");
      const parsed = stored ? JSON.parse(stored) : [];
      setPinnedMatches(parsed);
    } catch (err) {
      console.error("[Bookmaker] Failed to load pinned matches:", err);
    }
  }, []);

  // Fetch Bookmaker data and detect odds changes
  useEffect(() => {
    const fetchMultipin = async () => {
      const bookmakerMatches = pinnedMatches.filter((m) => m.bookmaker);
      const eventIds = bookmakerMatches.map((m) => m.id).join(",");
      if (!eventIds) {
        setMarketData([]);
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      try {
        const response = await BookmakerMultipin({ marketIDs: eventIds });
        console.log(
          `[${new Date().toISOString()}] BookmakerMultipin response:`,
          response
        );
        if (response?.data?.data) {
          const flattenedData = response.data.data.flat();

          // Detect odds changes
          const newBlinkCells = {};
          flattenedData.forEach((market, marketIdx) => {
            market.runners?.forEach((runner, idx) => {
              const runnerKey = `${market.marketId}-${runner.selectionId}`;
              const prevOdds = prevOddsRef.current[runnerKey] || {};

              ODDS_INDEXES.forEach((i) => {
                const backPrice =
                  runner.ex?.availableToBack?.[i]?.price || "--";
                const layPrice = runner.ex?.availableToLay?.[i]?.price || "--";
                const prevBackPrice = prevOdds.back?.[i] || "--";
                const prevLayPrice = prevOdds.lay?.[i] || "--";

                if (backPrice !== prevBackPrice) {
                  newBlinkCells[`back-${marketIdx}-${idx}-${i}`] = true;
                }
                if (layPrice !== prevLayPrice) {
                  newBlinkCells[`lay-${marketIdx}-${idx}-${i}`] = true;
                }
              });

              // Update previous odds
              prevOddsRef.current[runnerKey] = {
                back:
                  runner.ex?.availableToBack?.map((b) => b?.price || "--") ||
                  [],
                lay:
                  runner.ex?.availableToLay?.map((l) => l?.price || "--") || [],
              };
            });
          });

          setBlinkCells(newBlinkCells);
          setMarketData(flattenedData);

          // Clear blink effect after animation duration (0.5s * 2 = 1s)
          setTimeout(() => {
            setBlinkCells({});
          }, 1000);
        } else {
          setError("No data received from BookmakerMultipin");
        }
      } catch (err) {
        console.error("[Bookmaker] BookmakerMultipin error:", err);
        setError("Failed to fetch Bookmaker data. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchMultipin();
    // const interval = setIntervfal(fetchMultipin, 3000);
    // return () => clearInterval(interval);
  }, [pinnedMatches]);

  // Handle pin/unpin
  const handlePin = useCallback((eventId, event) => {
    event?.stopPropagation();
    let updatedMatches = JSON.parse(
      localStorage.getItem("pinnedMatches") || "[]"
    );
    const matchIndex = updatedMatches.findIndex(
      (m) => m.bmOdds[0]?.marketId === eventId
    );

    console.log(
      `[${new Date().toISOString()}] [Bookmaker] handlePin: eventId=${eventId}`
    );
    console.log(
      `[${new Date().toISOString()}] [Bookmaker] Before update:`,
      JSON.stringify(updatedMatches)
    );

    if (matchIndex !== -1) {
      console.log(
        `[${new Date().toISOString()}] [Bookmaker] Toggling bookmaker: eventId=${eventId}`
      );
      updatedMatches[matchIndex].bookmaker =
        !updatedMatches[matchIndex].bookmaker;
      if (
        !updatedMatches[matchIndex].matchOdds &&
        !updatedMatches[matchIndex].bookmaker
      ) {
        updatedMatches = updatedMatches.filter((m) => m.id !== eventId);
      }
    }

    console.log(
      `[${new Date().toISOString()}] [Bookmaker] After update:`,
      JSON.stringify(updatedMatches)
    );
    setPinnedMatches(updatedMatches);
    localStorage.setItem("pinnedMatches", JSON.stringify(updatedMatches));
  }, []);

  // Combine matches
  const allMatches = useMemo(
    () => [...cricket, ...soccer, ...tennis],
    [cricket, soccer, tennis]
  );

  // Handle bet selection
  const handleDataClick = useCallback(
    (runnerName, odds, type, runnerData, idx, marketIdx, market, runners) => {
      if (!odds || odds === "--") return;
      console.log(
        {
          allMatches,
          runnerName,
          marketData,
          odds,
          type,
          runnerData,
          idx,
          marketIdx,
          market,
          runners,
        },
        "aka"
      );

      const matchedMarket = allMatches.find(
        (e) => e?.bmOdds[0]?.marketId === market.marketId
      );
      if (!matchedMarket) return;

      const oddsData = {
        oddsType: type,
        odds,
        runnerName,
        selectionId: runnerData.selectionId,
        raceName: matchedMarket.eventName,
        markettype: "Bookmaker",
        marketId: market.marketId,
        matchId: matchedMarket.eventId,
        runners,
      };

      setLocalBetData(oddsData);
      setSelectedBet({
        marketId: market.marketId,
        selectionId: runnerData.selectionId,
        competitionId: matchedMarket.competitionId || "",
        eventName: matchedMarket.eventName || "",
        marketName: "Bookmaker",
        eventType: matchedMarket.sportId,
        eventId: matchedMarket.eventId,
        sportId: matchedMarket.sportName,
        markettype: "Bookmaker",
      });
    },
    [allMatches]
  );

  return (
    <div className="mt-1 md:mt-[25px]">
      <style>{`
        @keyframes blink {
          0% { background-color: #FFD949; }
          50% { background-color: #ffff99; }
          100% { background-color: #FFD949; }
        }
        
        .blink {
          animation: blink 0.5s ease-in-out 2;
        }
      `}</style>
      {marketData?.length > 0 ? (
        marketData?.map((market, marketIdx) => {
          const matchedMarket =
            allMatches.find(
              (e) => e?.bmOdds?.[0]?.marketId === market?.marketId
            ) || {};
          const pinnedMatch = pinnedMatches?.find(
            (m) => m.bmOdds?.[0]?.marketId === market?.marketId && m?.bookmaker
          );
          const isPinned = !!pinnedMatch;

          return (
            <div
              key={`${market?.eventId}-${market?.marketId}-${marketIdx}`}
              className="market-section"
            >
              <div className="bg-[#18adc5] w-full flex justify-between py-1 items-center">
                <div className="flex items-center">
                  <div
                    className={` Jarvis h-[18px] asian-pin-btn w-[18px] mt-[2px] border border-[#095771] ml-1 rounded flex items-center justify-center cursor-pointer ${
                      isPinned
                        ? "bg-[#095771] text-white"
                        : "hover:bg-[#095771] hover:text-white"
                    }`}
                    onClick={(e) => handlePin(market?.marketId, e)}
                    title={isPinned ? "Unpin Bookmaker" : "Pin Bookmaker"}
                  >
                    <BsFillPinFill
                      color={isPinned ? "#fff" : "#095771"}
                      size={14}
                    />
                  </div>
                  <span className="text-white px-1 text-[13px] font-bold">
                    {market.runners?.[0]?.runner || "Unknown"} v{" "}
                    {market.runners?.[1]?.runner || "Unknown"} (Bookmaker)
                  </span>
                </div>
              </div>
              <div className="bg-white overflow-hidden">
                <table
                  className="odds-table odds-table-asian"
                  role="grid"
                  aria-label={`Bookmaker for ${market.eventId}`}
                >
                  <thead className="head-hide-mobile">
                    <tr>
                      <th className="section-head">2 Selection</th>
                      <th className="market-top-head market-top-head-one"></th>
                      <th className="market-top-head"></th>
                      <th
                        className="market-top-head"
                        style={{ padding: "0px" }}
                      >
                        <div className="back-header">Back All</div>
                      </th>
                      <th
                        className="market-top-head"
                        style={{ padding: "0px" }}
                      >
                        <div className="lay-header">Lay All</div>
                      </th>
                      <th className="market-top-head"></th>
                      <th className="market-top-head market-top-head-last"></th>
                    </tr>
                  </thead>
                  <tbody
                    onClick={() =>
                      navigate(
                        `/full-market?eventType=${
                          matchedMarket?.sportId
                        }&eventId=${matchedMarket?.eventId}&marketId=${
                          matchedMarket?.marketId
                        }&joinedMarketIds=${
                          matchedMarket?.joinedMarketIds
                        }&competitionId=${matchedMarket?.competitionId}&bm=${
                          matchedMarket?.bm
                        }&fancy=${market?.fancy}&pc=${
                          matchedMarket?.pc
                        }&eventName=${encodeURIComponent(
                          matchedMarket?.eventName || ""
                        )}`
                      )
                    }
                    className={market.status?.toLowerCase()}
                  >
                    {market.runners?.map((runner, idx) => {
                      const runnerData =
                        matchedMarket.matchRunners?.find(
                          (data) => data?.selectionId === runner?.selectionId
                        ) || {};

                      return (
                        <tr
                          key={runner.selectionId}
                          className="asian-full-market"
                        >
                          <td
                            style={{
                              textAlign: "start",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              justifyContent: "space-between",
                            }}
                            colSpan={4}
                            className="runners-name"
                          >
                            <span className="flex flex-col w-full">
                              <p className="px-2">
                                {runner?.runner || "Unknown"}
                              </p>
                            </span>
                          </td>
                          {ODDS_INDEXES.slice()
                            .reverse()
                            .map((i) => (
                              <td
                                key={`back-${i}`}
                                className={`cursor-pointer asian-back${i} ${
                                  blinkCells[`back-${marketIdx}-${idx}-${i}`]
                                    ? "blink"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleDataClick(
                                    runner?.runner || "Unknown",
                                    runner?.ex?.availableToBack?.[i]?.price ||
                                      "--",
                                    "Back",
                                    runner,
                                    i,
                                    marketIdx,
                                    market,
                                    matchedMarket.matchRunners || market.runners
                                  )
                                }
                              >
                                {runner.ex?.availableToBack?.[i]?.price || "--"}
                                <br />
                                <span style={{ fontSize: "9px" }}>
                                  {runner.ex?.availableToBack?.[i]?.size || ""}
                                </span>
                              </td>
                            ))}
                          {ODDS_INDEXES.map((i) => (
                            <td
                              key={`lay-${i}`}
                              className={`cursor-pointer asian-lay${i} ${
                                blinkCells[`lay-${marketIdx}-${idx}-${i}`]
                                  ? "blink"
                                  : ""
                              }`}
                              onClick={() =>
                                handleDataClick(
                                  runner?.runner || "Unknown",
                                  runner?.ex?.availableToLay?.[i]?.price ||
                                    "--",
                                  "Lay",
                                  runner,
                                  i,
                                  marketIdx,
                                  market,
                                  matchedMarket.matchRunners || market.runners
                                )
                              }
                            >
                              {runner.ex?.availableToLay?.[i]?.price || "--"}
                              <br />
                              <span style={{ fontSize: "8px" }}>
                                {runner.ex?.availableToLay?.[i]?.size || ""}
                              </span>
                            </td>
                          ))}
                        </tr>
                      );
                    }) || (
                      <tr>
                        <td colSpan={7} className="text-center">
                          No runners available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {selectedBet && selectedBet.marketId === market.marketId && (
                <BettingSlip
                  data={marketData}
                  oddsData={localBetData}
                  newData={selectedBet}
                  onCancel={() => {
                    setSelectedBet(null);
                    setLocalBetData(null);
                  }}
                  nodelay={true}
                />
              )}
            </div>
          );
        })
      ) : (
        <div className="mt-1 md:mt-[25px]">No pinned Bookmaker matches</div>
      )}
    </div>
  );
};

export default React.memo(Bookmaker);
